import { adminHttpClient } from '../../commons/adminHttpClient'
import { NamedItem } from '../../../domain/common/namedItem'

export const getExpenseCategoriesForEmployee = (): Promise<NamedItem[]> => {
  return adminHttpClient.get('/EEDashboard/Perks/GetExpenseCategoriesForEmployee', {})
}
